import { createContext } from "react";
const BundleVersionContext = createContext();
export default BundleVersionContext;